/**
 * Whether the access window of a mail app shows "what Prest0n may see in email" (asset graph G4b,
 * docs/PLAN-asset-graph-20261011.md). The one lever: `REACT_APP_MAIL_PRIVACY_ACCOUNTS`, a list of workspace ids where
 * `*` admits every resolved workspace. Off when absent; deploy.yml ships it as `*` (`vars.MAIL_PRIVACY_ACCOUNTS`
 * narrows or, naming no workspace, turns it off). The rules themselves are enforced on the server whatever this says:
 * hiding the section only hides where people set them.
 */
import { buildEnv } from '../../config/buildEnv';

export const MAIL_PRIVACY_ACCOUNTS_ENV = 'REACT_APP_MAIL_PRIVACY_ACCOUNTS';

/** The apps whose mail the door guards (functions/src/assets/policies/mailActionClasses.ts). */
export const MAIL_PRIVACY_APPS: readonly string[] = ['gmail', 'outlook'];

export function mailPrivacyShows(
  slug: string | null | undefined,
  accountId: string | null | undefined,
  env: Record<string, string | undefined> = buildEnv(),
): boolean {
  if (!MAIL_PRIVACY_APPS.includes(String(slug || '').toLowerCase())) return false;
  const account = String(accountId ?? '').trim();
  if (!account) return false;
  const listed = new Set(
    String(env[MAIL_PRIVACY_ACCOUNTS_ENV] ?? '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean),
  );
  return listed.has('*') || listed.has(account);
}
